export default __webpack_public_path__ + "static/custom-fabrication-5eecfc9267e3305f5a0d1b812ed53105.jpg";